export default function makeColumnDefs (params = {}) {
  console.log('makeColumnDefs')

  const columnDefs = []

  columnDefs.push({
    headerName: 'Code',
    field: 'Code',
    pinned: 'left',
    width: 100
  })

  columnDefs.push({
    headerName: 'Accounting Code',
    field: 'AccountingCode',
    pinned: 'left',
    width: 100
  })

  columnDefs.push({
    headerName: 'Description',
    field: 'Description',
    pinned: 'left',
    width: 250
  })

  columnDefs.push({
    headerName: 'Rate',
    field: 'Rate',
    valueFormatter,
    cellClass,
    context: {
      decimals: 0
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'PRE-PROD Wks',
    field: 'PRE-PROD Wks',
    valueFormatter,
    cellClass,
    context: {
      decimals: 2
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'PRE-PROD Amount',
    field: 'PRE-PROD Amount',
    valueFormatter,
    cellClass,
    context: {
      decimals: 0
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'SHOOT Wks',
    field: 'SHOOT Wks',
    valueFormatter,
    cellClass,
    context: {
      decimals: 2
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'SHOOT Amount',
    field: 'SHOOT Amount',
    valueFormatter,
    cellClass,
    context: {
      decimals: 0
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'POST-PROD Wks',
    field: 'POST-PROD Wks',
    valueFormatter,
    cellClass,
    context: {
      decimals: 2
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'POST-PROD Amount',
    field: 'POST-PROD Amount',
    valueFormatter,
    cellClass,
    context: {
      decimals: 0
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'Total Production',
    field: 'TotalProduction',
    valueFormatter,
    cellClass,
    context: {
      decimals: 0
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'QAPE',
    field: 'QAPE',
    valueFormatter,
    context: {
      decimals: 0
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'Stage of Production',
    field: 'Stage of Production'
  })

  return columnDefs
}

function cellClass (cellParams) {
  const classes = ['right', 'number']
  if (Number.isFinite(cellParams.value) && cellParams.value === 0) {
    classes.push('zero')
  }
  return classes
}

function valueFormatter (cellParams) {
  if (!cellParams.value) return cellParams.value
  let value = formatNumber(cellParams.value, cellParams.context.numberPowTen)

  const decimals = cellParams.colDef.context.decimals || 0
  value = applyNumberFormat(value, decimals)
  return value
}

function applyNumberFormat (value, decimals) {
  const customFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
  return customFormatter.format(value)
}

function formatNumber (value, numberPowTen) {
  if (!Number.isFinite(value)) return value
  return value / Math.pow(10, numberPowTen)
}
